'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PropTypes = _react2['default'].PropTypes;


var string = PropTypes.string;
var number = PropTypes.number;
var stringOrNumber = PropTypes.oneOfType([string, number]);
var maybeStringArray = PropTypes.oneOfType([string, PropTypes.arrayOf(string)]);
var maybeNumberArray = PropTypes.oneOfType([number, PropTypes.arrayOf(number)]);
var maybeStringOrNumberArray = PropTypes.oneOfType([stringOrNumber, PropTypes.arrayOf(stringOrNumber)]);

exports['default'] = {
    alignItems: maybeStringArray,
    backgroundColor: maybeStringArray,
    bg: maybeStringArray,
    borderColor: maybeStringArray,
    border: maybeNumberArray,
    borderBottom: maybeNumberArray,
    borderLeft: maybeNumberArray,
    borderRight: maybeNumberArray,
    borderTop: maybeNumberArray,
    color: maybeStringArray,
    display: maybeStringArray,
    flex: maybeStringOrNumberArray,
    flexDirection: maybeStringArray,
    flexWrap: maybeStringArray,
    fontSize: maybeNumberArray,
    fontWeight: maybeStringOrNumberArray,
    hoverColor: maybeStringArray,
    justifyContent: maybeStringArray,
    m: maybeStringOrNumberArray,
    margin: maybeStringOrNumberArray,
    marginBottom: maybeStringOrNumberArray,
    marginLeft: maybeStringOrNumberArray,
    marginRight: maybeStringOrNumberArray,
    marginTop: maybeStringOrNumberArray,
    marginX: maybeStringOrNumberArray,
    marginY: maybeStringOrNumberArray,
    mb: maybeStringOrNumberArray,
    ml: maybeStringOrNumberArray,
    mr: maybeStringOrNumberArray,
    mt: maybeStringOrNumberArray,
    mx: maybeStringOrNumberArray,
    my: maybeStringOrNumberArray,
    order: maybeNumberArray,
    p: maybeNumberArray,
    padding: maybeNumberArray,
    paddingBottom: maybeNumberArray,
    paddingLeft: maybeNumberArray,
    paddingRight: maybeNumberArray,
    paddingTop: maybeNumberArray,
    paddingX: maybeNumberArray,
    paddingY: maybeNumberArray,
    pb: maybeNumberArray,
    pl: maybeNumberArray,
    position: maybeStringArray,
    pr: maybeNumberArray,
    pt: maybeNumberArray,
    px: maybeNumberArray,
    py: maybeNumberArray,
    textAlign: maybeStringArray,
    textTransform: maybeStringArray,
    verticalAlign: maybeStringArray,
    width: maybeNumberArray
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/blocks/lib/prop-types.js
 ** module id = 414
 ** module chunks = 0 1
 **/